export default __webpack_public_path__ + "static/media/nike.87eb87af.png";